import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

export const buttonWrapperStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding-bottom: 24px;

  ${MEDIA_QUERY_FOR_SP} {
    padding-left: 16px;
    padding-right: 16px;
  }
`;
